/*
 * @file: 工具集
 */

import moment from "moment";
import * as _ from "lodash-es";
import safeGet from "@fengqiaogang/safe-get";

import * as AES from "./tool/aes";
import * as data from "./tool/data";
import {md5 as MD5} from "./tool/md5";
import * as cookie from "./tool/cookie";
import * as BASE64 from "./tool/base64";
import * as session from "./tool/session";


export const isTapd = function (template) {
  if (template && typeof template === "object") {
    const value = safeGet(template, 'flowTemplate');
    return isTapd(value);
  }
  if (template) {
    return _.toLower(template) === "tapd";
  }
  return false;
}
/* Fullscreen */
const screen = function (element) {
  var isFull = !!(document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
  if (isFull) {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    }
  } else {
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    } else if (element.mozRequestFullScreen) {
      element.mozRequestFullScreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    }
  }
}

const objCopy = function (value) {
  if (_.isObject(value)) {
    return _.cloneDeep(value);
  }
  return value;
}

const dateFormat = function (date, fmt = 'yyyy-MM-dd hh:mm:ss') {
  const data = moment(new Date(date));
  return data.format(fmt);
}
/* 千分符 */
const groupSeparator = function (num) {
  num = num + '';
  if (!num.includes('.')) {
    num += '.'
  }
  return num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
    return $1 + ',';
  }).replace(/\.$/, '');
}


const tool = {
  screen,
  objCopy,
  dateFormat,
  groupSeparator,
  data,
  session,
  cookie,
  crypto: {
    MD5, BASE64, AES
  }
};

export default tool
